<template>
    <div id="body">
        <b-container>
            <div class="box-nangluc">
                
                <img class="img-nangluc" src="@/assets/ver2/nangluctienganh.png">
                
                <ContactForm
                v-model="form"
                :step="form.step"
                @change-step="ChangeStep"
                />

                <!-- error message -->

                <div v-if="error">
                    <div class="container">
                        <div class="text-center">
                            <p class="text-danger h4 bold">{{ error.msg }}</p>
                        </div>
                    </div>
                </div>

                <!-- error message end -->
            </div>
        </b-container>
        
        <div class="img-decor">
            <img class="img-human-left" src="@/assets/ver2/human-left.png">
            <img class="img-human-right" src="@/assets/ver2/human-right.png">
        </div>
    </div>
</template>

<script>

// mixins import
import Page1 from '@/plugins/TestPlugin/mixins/page1'

import ContactForm from '@/components/ContactForm.vue'

export default {
    mixins: [Page1],
    data() {
        return {}
    },

    components: {
        ContactForm
    },
    computed: {
       
    },
    watch: {
    },
    methods: {
       
    },
    
    created() {
    },
}
</script>

<style lang="scss" scoped>

    #body {

        overflow: hidden;
        position: relative;
        min-height: calc(100vh - 60px);

        .img-decor{
            // z-index: 0;
            // position: absolute;
            // left: 50%;
            // transform: translateX(-50%);
            
            width: 100%;
            // height: 34px;
            position: relative;
            bottom: 200px;


            .img {
                &-human-left{
                    position: absolute;
                    width: 30%;
                    max-width: 300px;
                }
                &-human-right{
                    position: absolute;
                    width: 30%;
                    max-width: 300px;
                    right: 0;
                }
            }
        }
    }

    .box-nangluc {
        position: relative;
        text-align: center;
        .img{
            &-nangluc{
                max-width: 65rem;
            }
        }
        .form-regsiter {
            position: relative;
            z-index: 1;
            width: 25rem;
            margin: 0 auto;
            text-align: center;
            .input_custom {
                margin-bottom: 1rem;
                border: 5px solid black;
                border-radius: 19px;
                font-size: 1rem;
                box-shadow: 3px 5px #009933;
            }
            .button_next{
                margin-top: 1rem;
                img{
                    cursor: pointer;
                    max-width: 12rem;
                }
            }
        }
    }
    @media (min-width: 1170px) and (max-width: 1400px) {
        
    }
</style>